import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  Col,
  Container,
  Row,
  Badge,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Link, useNavigate } from "react-router-dom";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";
import ServiceIntellWidgets from "../../../services/KangarooServices/Intelligence/ServiceIntellWidgets";
import ServiceWidgetForm from "../component/ServiceWidgetForm";
import { Triangle } from "react-loader-spinner";
import noimage from "../../../assets/kangaroo/noimage.png";

const ServiceWidget = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  console.log("🚀 ~ ServiceWidget ~ selectedDeleteItem:", selectedDeleteItem);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);
  const [isMain, setIsMain] = useState(false);
  const toggleWidget = (item) => {
    setSelectedItem(item);
    setIsWidgetOpen(!isWidgetOpen);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await ServiceIntellWidgets.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    if (item?.serviceId) {
      setIsMain(true);
    } else {
      setIsMain(false);
    }
    toggleDelete();
  };
  const handleDelete = async () => {
    setLoading(true);
    if (selectedDeleteItem) {
      try {
        if (isMain === true) {
          await ServiceIntellWidgets.deleteMain(selectedDeleteItem?.serviceId);
        } else {
          await ServiceIntellWidgets.delete(selectedDeleteItem);
        }
        setLoading(true);
        fetchData();
        toast.success("Widget deleted successfully");
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to delete widget",
        );
      } finally {
        setLoading(false);
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Service Widgets" pageTitle="Widget Setup" />
        {loading ? (
          <Row>
            <Col className="text-center py-5">
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
              </div>
            </Col>
          </Row>
        ) : data?.length === 0 ? (
          <Row>
            <Col>
              <Card>
                <CardBody className="text-center py-5">
                  <i className="ri-message-3-line display-4 text-muted"></i>
                  <h5 className="mt-3 mb-2">No Service Widgets found</h5>
                  <p className="text-muted mb-4">
                    Get started by creating first service widget
                  </p>
                  <Button color="success" onClick={() => toggleWidget(null)}>
                    <i className="bi bi-plus-lg me-1"></i>
                    New Service Widget
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        ) : (
          <>
            <Row className="mb-4">
              <Col>
                <div className="d-flex justify-content-between align-items-center">
                  <Button color="success" onClick={() => toggleWidget(null)}>
                    <i className="bi bi-plus-lg me-1"></i>
                    Add Service Widget
                  </Button>
                </div>
              </Col>
            </Row>

            <Row xs="1" md="2" lg="3" className="g-4">
              {data?.map((country) => (
                <Col key={country.serviceId}>
                  <Card className="h-100 shadow-sm border-0 widget-card">
                    {/* Header */}
                    <div className="card-header bg-light border-0 d-flex justify-content-between align-items-center">
                      <h6 className="mb-0 fw-semibold">
                        🌍 {country.serviceName}
                      </h6>
                      <span className="badge bg-primary">
                        {country.widgets?.length || 0} Widgets
                      </span>
                    </div>

                    {/* Body */}
                    <CardBody className="">
                      {country.widgets?.length > 0 ? (
                        country.widgets.map((widget) => (
                          <div
                            key={widget.id}
                            className="d-flex gap-3 align-items-start mb-3 rounded widget-item"
                          >
                            {/* Image */}
                            {widget.image?.url && (
                              <img
                                src={
                                  widget?.image?.url
                                    ? `${imageBaseApi}${widget.image.url}`
                                    : noimage
                                }
                                // src={`${imageBaseApi}${widget.image.url}`}
                                alt={widget.name || "Service widget"}
                                className="rounded"
                                width="55"
                                height="55"
                                style={{ objectFit: "contain" }}
                              />
                            )}

                            {/* Content */}
                            <div className="flex-grow-1">
                              <p className="mb-1 fw-medium">{widget.name}</p>
                              <small className="text-muted">
                                {widget.description
                                  ? widget.description
                                      .replace(/<[^>]+>/g, "")
                                      .slice(0, 60) + "..."
                                  : "No description available"}
                              </small>
                            </div>
                            <div>
                              <Button
                                size="sm"
                                color="danger"
                                outline
                                onClick={() => handleDeleteClick(widget?.id)}
                                title="Delete country widgets"
                              >
                                <i className="ri-delete-bin-5-line"></i>
                              </Button>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="text-muted text-center mb-0">
                          No widgets available
                        </p>
                      )}
                    </CardBody>

                    {/* Footer */}
                    <CardFooter className="bg-white border-0 pt-0">
                      <div className="d-flex justify-content-end gap-2">
                        {/* <Button
                          size="sm"
                          color="info"
                          outline
                          onClick={() =>
                            navigate(
                              `/service-widgets/details/${country.serviceId}`,
                            )
                          }
                          title="View country widgets"
                        >
                          <i className="ri-eye-line"></i>
                        </Button> */}
                        <Button
                          size="sm"
                          color="warning"
                          outline
                          onClick={() => toggleWidget(country)}
                          title="Edit country widgets"
                        >
                          <i className="ri-edit-line"></i>
                        </Button>
                        <Button
                          size="sm"
                          color="danger"
                          outline
                          onClick={() => handleDeleteClick(country)}
                          title="Delete country widgets"
                        >
                          <i className="ri-delete-bin-5-line"></i>
                        </Button>
                      </div>
                    </CardFooter>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}
      </Container>
      <ServiceWidgetForm
        isOpen={isWidgetOpen}
        toggle={toggleWidget}
        selectedItem={selectedItem}
        fetchData={fetchData}
      />

      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </div>
  );
};

export default ServiceWidget;
